export function Header(): string {
  return /*html*/ `
    <h1>Todo App</h1>
  `;
}
